class StoreLocatorCtaInjector {
  constructor(customLink, options = {}) {
    this.customLink = customLink;
    this.options = {
      targetSelector: '.storepoint-no-results-actions',
      widgetContainerSelector: '#storepoint-widget',
      buttonText: 'Prenota una video consulenza',
      fallbackDelay: 2000,
      ...options
    };

    this.observer = null;
    this.isInjected = false;
  }

  init() {
    if (!this.customLink) {
      return;
    }

    this.setupObserver();
    this.setupFallback();
  }

  setupObserver() {
    const widgetContainer = document.querySelector(this.options.widgetContainerSelector);

    if (!widgetContainer) {
      console.warn('StoreLocatorCtaInjector: Widget container not found');
      return;
    }

    this.observer = new MutationObserver((mutations) => {
      if (!this.isInjected) {
        this.injectButton();
      }
    });

    this.observer.observe(widgetContainer, {
      childList: true,
      subtree: true
    });
  }

  setupFallback() {
    setTimeout(() => {
      if (!this.isInjected) {
        this.injectButton();
      }
    }, this.options.fallbackDelay);
  }

  injectButton() {
    const targetContainer = document.querySelector(this.options.targetSelector);

    if (!targetContainer) {
      return;
    }

    const originalButton = targetContainer.querySelector('.storepoint-widget-button');
    if (!originalButton) {
      setTimeout(() => this.injectButton(), 200);
      return;
    }

    if (targetContainer.querySelector('.storepoint-widget-button--custom')) {
      return;
    }

    const buttonText = originalButton.textContent.trim();

    originalButton.style.setProperty('display', 'none', 'important');

    const button = document.createElement('button');
    button.className = 'storepoint-widget-button storepoint-widget-button--custom';
    button.textContent = buttonText;
    button.addEventListener('click', (e) => {
      e.preventDefault();
      window.open(this.customLink, '_blank');
    });

    targetContainer.appendChild(button);

    this.isInjected = true;

    if (this.observer) {
      this.observer.disconnect();
    }

    console.log('StoreLocatorCtaInjector: Button injected successfully');
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    const button = document.querySelector('.storepoint-widget-button--custom');
    if (button) {
      button.remove();
    }

    this.isInjected = false;
  }
}

window.StoreLocatorCtaInjector = StoreLocatorCtaInjector;

document.addEventListener('DOMContentLoaded', function() {
  const scriptTag = document.querySelector('script[src*="section-store-locator-embed.js"]');
  const customLink = scriptTag ? scriptTag.dataset.customLink : null;

  if (!customLink || customLink.trim() === '') {
    return;
  }

  const injector = new StoreLocatorCtaInjector(customLink);
  injector.init();
});
